export default __webpack_public_path__ + "static/media/BluetoothImg.531dca2f.jpg";